module.exports = __webpack_public_path__ + "static/media/view_po_2.1a933884.png";